export default "__VITE_ASSET__DziEYml0__"